import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { useUserRole } from "@/hooks/useUserRole";

/**
 * Hook to fetch the count of unresolved internal errors.
 * Only fetches for admin users.
 */
export function useUnresolvedErrorCount() {
  const { user } = useAuth();
  const { isAdmin } = useUserRole();

  const { data: count = 0, isLoading } = useQuery({
    queryKey: ["unresolved-error-count"],
    queryFn: async () => {
      const { count, error } = await supabase
        .from("internal_errors")
        .select("*", { count: "exact", head: true })
        .eq("resolved", false);

      if (error) throw error;
      return count ?? 0;
    },
    enabled: !!user && isAdmin,
    staleTime: 1000 * 60 * 2, // 2 minutes
    refetchInterval: 1000 * 60 * 5, // Refresh every 5 minutes
  });

  return { count, isLoading };
}
